// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPayrollContributionsMultiEmployersSummaryRecordDto } from './IPayrollContributionsMultiEmployersSummaryRecordDto';
import {
    IPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON,
    IPayrollContributionsMultiEmployersSummaryRecordDtoFromJSONTyped,
    IPayrollContributionsMultiEmployersSummaryRecordDtoToJSON,
    IPayrollContributionsMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IPayrollContributionsMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IPayrollContributionsMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto
     */
    subsidiary_records?: Array<IPayrollContributionsMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    return IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IPayrollContributionsMultiEmployersSummaryRecordDtoToJSON)),
    };
}

